<template>
	<div class="content">
		<div class="backgo" @click="back()"><img src="../../assets/img/back.png" alt=""><div>返回</div></div>
		<div class="cont_title">班级列表</div>
		<div class="top">
			<el-input style="width: 280px;margin-right: 30px;" 
			@keyup.enter.native="getList" v-model="queryParams.keywords" placeholder="请输入班级名称查询" type="text"/>
			<el-button icon="el-icon-search" type="primary" @click="getList()">查询</el-button>
		</div>
		<el-table style="width: 100%;margin-top: 30px;" border :data="tableData" :header-cell-style="{background: '#F5F6F7'}">
			<el-table-column prop="id" label="#" width="50" align="center"/>
			<el-table-column prop="class_name" label="班级名称" align="center"/>
			<el-table-column prop="department_name" label="所属院系" align="center"/>
			<el-table-column prop="count" label="学生数量" align="center"/>
			<el-table-column prop="teacher_name" label="授课老师" align="center"/>
			<!-- <el-table-column  label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click="goxue(scope.row)" type="text" size="small">学生列表</el-button>
					<el-button @click="goke(scope.row)" type="text" size="small">课程列表</el-button>
				</template>
			</el-table-column> -->
		</el-table>
		<div class="block" style="margin-top: 20px;text-align: center;">
			<el-pagination background @current-change="handleCurrentChange" 
			:current-page="currentPage" layout="prev, pager, next" :total="total"></el-pagination>
		</div>
		
	</div>
</template>
<script>
import {kecheng_banji} from "../../api/new.js";	
	export default {
		data() {
			return {
				
				id:'',
				loading: false,
				tableData: [],
				queryParams:{
					keywords:'',
					limit:10,
					page:1,
					kecheng_id:'',
				},
				total: 0,
				currentPage: 1,
			};
		},
		
		mounted() {
			this.queryParams.kecheng_id = this.$route.query.id
			this.getList()
		},
		methods: {
			//课程班级列表
			getList(){
				var _this = this
				this.loading = true
				kecheng_banji(this.queryParams).then((res) => {
					this.loading = false
					if (res.code == 0) {
						this.tableData = res.data
						this.total = res.total
					} else {
						this.$message.error(res.msg);
					} 
				})
				.catch((err) => {
					this.loading1 = false
				});	
			},
			back(){
				this.$router.go(-1);
			},
			goxue(){
				this.$router.push({
				  path: "/zuoStudent",
				  query: {
				    id: "1",
				  },
				});
			},
			goke(){
				this.$router.push({
				  path: "/bCourse",
				  query: {
				    id: "1",
				  },
				});
			},
			goDetails() {
				this.$router.push({
				  path: "/sTeacherInfo",
				  query: {
				    id: "1",
				  },
				});
			},
			//班级列表上一页，下一页
			handleCurrentChange(currentPage) {
				this.queryParams.page = currentPage;
				this.currentPage = currentPage;
				this.getList()
			},
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1200px;
	background: #FFFFFF;
	border-radius: 20px;
	padding: 30px;	
	
	.top{
		width: 100%;
		display: flex;
		align-items: center;
		// justify-content: space-between;
		margin-top: 50px;
		.top_rig{
			display: flex;
			margin-left: auto;
		}
		.zujuan_btn{
			width: 140px;
			height: 44px;
			background: #4076F3;
			border-radius: 10px;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 44px;
			text-align: center;
			cursor: pointer;
			margin-left: 35px;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}
		}
		.btn1{
			background: #ED7F26;
		}
		.btn2{
			background: #E13049;
		}
		.zujuan_btn:hover{
			opacity: 0.7;
		}
		.zujuan_btn:active{
			opacity: 0.9;
		}
	}
	
}	
</style>



// WEBPACK FOOTER //
// src/components/zuoye/zuoBan.vue